
import React, { useState, useEffect, useCallback, useRef } from 'react';
import style from './style.module.css';
import { renderState, visibleState } from '../../utils/conditionalState';
import api from '../../api';
import platform from 'geeky-platform';

import Navigation from '../Navigation';
import Collection from '../Collection';

import GoalItem from '../GoalItem';
import GroupSelector from '../GroupSelector';
import GroupJoin from '../GroupJoin';
import GroupStart from '../GroupStart';
import RequestItem from '../RequestItem';
import AlertDialog from '../AlertSelect';
import GeoLocation, { distanceBetween } from '../GeoLocation';
import GeoEarn from '../GeoEarn';
import GeoItem from '../GeoItem';

const Geo = props => {

    const [locations, setLocations] = useState([]);
    const [status, setStatus] = useState('loading');
    const [selectedCategory, setSelectedCategory] = useState('leaderboards');

    const [position, setPosition] = useState(null);
    const [accuracy, setAccuracy] = useState('DEMO');
    // const [target, setTarget] = useState({ lat: 37.7955, lon: -122.3937 });
    const [heading, setHeading] = useState(null);
    const [searching, setSearching] = useState(false);
    const [initialDistance, setInitialDistance] = useState(640);

    const watchIdRef = useRef(null);
    const compassActiveRef = useRef(false);
    const bestAccuracyRef = useRef(Infinity);
    const lastPositionRef = useRef(null);

    const calculateDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371e3;
        const φ1 = (lat1 * Math.PI) / 180;
        const φ2 = (lat2 * Math.PI) / 180;
        const Δφ = ((lat2 - lat1) * Math.PI) / 180;
        const Δλ = ((lon2 - lon1) * Math.PI) / 180;

        const a = Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    };

    const fetch = async () => {
        const items = await api.geo.list();
        setLocations(items);
        console.log(items);
        setStatus('accepted');
    };

    const startLocationWatch = useCallback(() => {
        if (!navigator.geolocation) {
            // triggerToast('GEOLOCATION IS NOT SUPPORTED');
            return false;
        }

        if (watchIdRef.current !== null) navigator.geolocation.clearWatch(watchIdRef.current);

        // setIsLocationDisabled(true);
        // setLocationBtnText('FINDING YOUR LOCATION…');

        bestAccuracyRef.current = Infinity;

        const onPosition = ({ coords, timestamp }) => {
            // 1. Hard accuracy threshold
            setSearching(true);
            if (coords.accuracy > 10) return;

            if (lastPositionRef.current) {
                const prev = lastPositionRef.current;
                const distance = calculateDistance(prev.lat, prev.lon, coords.latitude, coords.longitude);
                const timeElapsed = (timestamp - prev.timestamp) / 1000; // seconds

                // 2. Teleportation filter (drop spikes faster than 30 m/s ~ 108 km/h)
                if (timeElapsed > 0 && distance / timeElapsed > 30) return;

                // 3. Static jitter filter (ignore movement smaller than current accuracy radius)
                if (distance < coords.accuracy / 2) return;
            }

            const newPos = {
                lat: coords.latitude,
                lon: coords.longitude,
                accuracy: coords.accuracy,
                timestamp,
            };

            lastPositionRef.current = newPos;

            setPosition({ lat: coords.latitude, lon: coords.longitude });
            setAccuracy(`±${Math.round(coords.accuracy)}m`);
            setStatus('accepted');
            // onUpdate(newPos);
        };

        // const onPosition = ({ coords }) => {
        //     // 1. Ignore fixes with poor accuracy (e.g., cell tower fixes > 20m)
        //     if (coords.accuracy > 10) return;

        //     // 2. Only accept updates that maintain or improve accuracy 
        //     // (allows small degradation if user moved significantly)
        //     if (coords.accuracy <= bestAccuracyRef.current || coords.accuracy <= 10) {
        //         bestAccuracyRef.current = coords.accuracy;

        //         setPosition({ lat: coords.latitude, lon: coords.longitude });
        //         setAccuracy(`±${Math.round(coords.accuracy)}m`);
        //         setStatus('accepted');
        //     }
        // };

        // const onPosition = ({ coords }) => {
        //     setPosition({ lat: coords.latitude, lon: coords.longitude });
        //     setAccuracy(`±${Math.round(coords.accuracy)}M`);
        //     setStatus('accepted');
        //     // setLocationBtnText('LIVE LOCATION ACTIVE');
        //     // setLocationBtnHint('GPS position updating');
        //     // setIsLocationDisabled(false);
        // };

        const onError = (error) => {

        };

        navigator.geolocation.getCurrentPosition((pos) => {
            onPosition(pos);

            watchIdRef.current = navigator.geolocation.watchPosition(onPosition, onError, {
                enableHighAccuracy: true,
                maximumAge: 0,
                timeout: 20000,
            });
        }, onError, { enableHighAccuracy: true, maximumAge: 0, timeout: 20000 });
    }, []);

    const handleEnableCompass = async () => {
        if (compassActiveRef.current || typeof window.DeviceOrientationEvent === 'undefined') return;

        try {
            if (typeof window.DeviceOrientationEvent.requestPermission === 'function') {
                const permission = await window.DeviceOrientationEvent.requestPermission();

                if (permission !== 'granted') {
                    return;
                }
            }

            window.addEventListener('deviceorientation', (event) => {
                const headingVal = typeof event.webkitCompassHeading === 'number' ? event.webkitCompassHeading : typeof event.alpha === 'number' ? 360 - event.alpha : null;
                if (headingVal !== null && !Number.isNaN(headingVal)) {
                    setHeading((headingVal + 360) % 360);
                }
            }, { passive: true });

            compassActiveRef.current = true;
        } catch (e) {

        }
    };

    const add = async () => {
        console.log('add')

        // if (!position) return;

        // const test = {
        //     title: 'Coehadjoe Park',
        //     clue: 'Go slightly past the tennis courts...',
        //     passport: 'Coehadjoe Park',
        //     subtitle: 'You did it!',
        //     lat: 29.2279979, // position.lat, // 
        //     lon: -82.0747285, // position.lon, // 
        //     image: 'result.data.image',
        //     thumbnail: 'result.data.thumbnail',
        //     color: '#508695'
        // };

        // try {
        //     const result = await api.geo.add(test);
        //     console.log(result);
        //     fetch();
        // } catch (e) {
        //     console.log(e);
        // }
    };

    const select = async (data) => {
        try {
            // const result = await api.geo.edit(data._id, { title: 'test' });
            // const result = await api.geo.archive(data._id);

            platform.request({ id: 'linkManager', data: { url: `https://maps.apple.com/?daddr=${data.lat},${data.lon}` } });
            // console.log(result);
            fetch();
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => { fetch() }, [props.fetchData]);

    const distance = data => {
        if (!position) return null;

        const target = { lat: data.lat, lon: data.lon };
        const distance = distanceBetween(position, target);

        const useMiles = distance >= 1609.34; // Switch to miles at ~1 mile (1609.34 meters)
        const distanceDisplay = useMiles
            ? (distance / 1609.34).toFixed(1)
            : Math.round(distance * 3.28084);
        const distanceUnit = useMiles ? 'mi.' : 'ft.';
        // const headingFormatted = String(Math.round(bearing)).padStart(3, '0');
        // const eta = `${Math.max(1, Math.round(distance / 80))} MIN`;
        // const complete = Math.max(2, Math.min(96, (1 - distance / initialDistance) * 100));
        return `${distanceDisplay} ${distanceUnit}`;
    };

    const content = renderState(status, {
        permissions: () => (
            <div className={style.welcome}>
                <div className={style.getStartedTip}>
                    Welcome to AMP Rangers! To get started, please allow location access.
                </div>
            </div>
        ),
        accepted: () => (
            <div>
                <div className={style.tipContainer}>
                    <div className={style.TipItem}>
                        {/* <div className={style.tipIcon}>Lightbulb</div> */}
                        {/* lightbulb */}
                        <div className={style.tipInfo}>
                            <div className={style.tipTitle}>Welcome to Rangers!</div>
                            <div className={style.tipDescription}>You can get a mystery passport by visiting nearby places.</div>
                            {/* <div className={style.look}>Look for passports here</div> */}
                            {/* <div style={{ fontSize: '10px' }}>{JSON.stringify(position)}</div> */}
                            {/* <div style={{ fontSize: '10px' }}>{heading}</div> */}

                            {/* <button onClick={() => { handleEnableCompass(); startLocationWatch() }}>COMPASS</button> */}

                            <div className={style.toolbar}>
                                <div className={style.progressButton} onClick={() => { handleEnableCompass(); startLocationWatch() }}>{searching ? 'Searching Nearby...' : 'Search Nearby'}</div>
                            </div>
                            {/* {itemData.description && itemData.description.length ? <div className={style.description}>{itemData.description}</div> : null} */}
                        </div>
                    </div>
                    <div className={style.tipOverlay}>NEARBY</div>
                </div>

                <div className={style.collection}>
                    {locations.map((data, index) => (
                        <GeoItem
                            key={index}
                            data={{ ...data, index }}
                            onSelect={() => select(data)}
                            distance={data => distance(data)} />
                    ))}
                </div>
                {/* <Collection
                    listLayout
                    items={locations}
                    itemType={'geo'}
                    component={GoalItem}
                    footerComponent={null}
                    onSelect={select} /> */}
            </div>
        ),
        loading: () => null
    });

    const nearby = position ? locations.sort((a, b) => distanceBetween(position, { lat: a.lat, lon: a.lon }) - distanceBetween(position, { lat: b.lat, lon: b.lon })) : [];
    const closest = nearby.length ? nearby[0] : null;
    const active = false //position && heading != null && closest && (distanceBetween(position, { lat: closest.lat, lon: closest.lon }) * 3.28084) < 100 ? closest : null;

    return (
        <Navigation hideNavigationBar={active} navigationTitle={'AMP Rangers'}>
            {active ? (
                <GeoLocation id={closest._id} badge={closest} name={closest.title} heading={heading} position={position} destination={{ lat: closest.lat, lon: closest.lon }} onEarn={() => props.onEarn()} />
            ) : (
                <div className={style.content}>
                    <div>
                        {content}
                        {/* <button style={{ width: '200px', height: '200px' }} onClick={() => add()}>add</button> */}
                    </div>
                </div>
            )}



            {/* <div className={style.content}>
                <div className={style.selector}>
                    <GroupSelector
                        // categories={extrtaTab ? [...categories, 'Analytics'] : categories}
                        categories={categories}
                        selectedIndex={categoryIds.indexOf(selectedCategory)}
                        onSelect={index => setSelectedCategory(categoryIds[index])} />
                </div>
                {tabsContent}
            </div>
            <GroupJoin visible={showGroupJoin} onFinish={finishModal} />
            <GroupStart visible={showGroupStart} onFinish={finishModal} /> */}
        </Navigation>
    );

};

export default Geo;
